import React from 'react';
import PhotoUploader from './polaroid'
export default function App(props) {
  return (
    <div>
    <PhotoUploader/>
    </div>
  );
}
